// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconHome } from '@tabler/icons';

const icons = {
    IconHome
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const chartedAccount = {
    id: 'charted-account',
    title: <FormattedMessage id="CA" />,
    icon: icons.IconHome,
    type: 'group',
    url: 'charted-account',
    roles: ['admin']
};

export default chartedAccount;